import { StandardToggleButton, CommonToggleButtonProps } from './TooggleButton'

const AssessmentIconButton: React.FC<CommonToggleButtonProps> = ({ id, active, disabled, onClick }) => (
    <StandardToggleButton
        id={id}
        color={'primary'}
        icon={'GradeRounded'}
        disabled={disabled}
        onClick={onClick}
        selected={active}
    />
)

export { AssessmentIconButton }
